module.exports = __webpack_public_path__ + "media/images/business/illust-case-01-9ca95e7aa92579f03665d43537b3c518.svg";